exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".checkbox-demo-wrapper{padding:0 15px}.checkbox-demo-wrapper .zan-checkbox{margin:10px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-42176c3e!./~/vue-loader/lib/selector.js?type=styles&index=0!./docs/examples/checkbox.vue
// module id = 228
// module chunks = 0